import React from "react";

export type ToggleButtonProps = {
  selected?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  text1?: string;
  text2?: string;
};

const containerClasses = [
  "ToggleContainer",
  "toggle-container",
  "w-full",
  "bg-button-background",
  "cursor-pointer",
  "select-none",
  "rounded-button",
  "h-10",
  "relative",
  "flex",
  "justify-around",
  "items-center",
  "p-0",
  "my-3"
].join(" ");

const buttonBaseClasses = [
  "text-collins-md",
  "leading-4",
  "font-bold",
  "cursor-pointer",
  "text-primary-color",
  "p-2.5",
  "h-9",
  "text-center",
  "rounded-button",
  "flex-1"
].join(" ");

const selectedClasses = [
  "bg-button-default",
  "text-button-default-foreground",
  "font-normal",
  "border",
  "border-button-default"
].join(" ");

const deselectedClasses = [
  "toggle-deselected",
  "bg-button-background",
  "font-normal",
  "text-[var(--tertiaryColor)]"
].join(" ");

export function ToggleButton({
  text1,
  text2,
  selected,
  onClick
}: ToggleButtonProps) {
  const leftButtonClasses = [
    "LeftButton",
    buttonBaseClasses,
    selected
      ? `ShowSelected ${selectedClasses}`
      : `ShowDeselected ${deselectedClasses}`
  ].join(" ");

  const rightButtonClasses = [
    "RightButton",
    buttonBaseClasses,
    selected
      ? `ShowDeselected ${deselectedClasses}`
      : `ShowSelected ${selectedClasses}`
  ].join(" ");

  return (
    <div className={containerClasses} onClick={onClick} aria-hidden="true">
      <div className={leftButtonClasses}>{text1}</div>
      <div className={rightButtonClasses}>{text2}</div>
    </div>
  );
}
